function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`animate-pulse rounded-md bg-muted ${className}`} {...props}></div>;
}

function SkeletonDark({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <Skeleton className={`bg-gray-200/50 ${className}`} {...props} />;
}

export { Skeleton, SkeletonDark };
